import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IAppState } from '../../store/state';
import { selectIsLogged } from '../../store/selectors';

/**
 * Redireciona para a raiz do tenant (`/{tenant}`, rota de login) quando não
 * autenticado. Usa `paramsInheritanceStrategy: 'always'` (ver
 * app-routing.module.ts) para conseguir ler o slug do tenant mesmo em rotas
 * filhas aninhadas dentro de `:tenant`.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private store: Store<IAppState>, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const tenantSlug = route.paramMap.get('tenant') ?? '';
    return this.store.select(selectIsLogged).pipe(
      take(1),
      map((isLogged) => isLogged || this.router.createUrlTree([`/${tenantSlug}`]))
    );
  }
}
